import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadPerms = async () => {
    try {
      const { data } = await api.get("/permissions");
      setPerms(data.permissions);
      return data.permissions;
    } catch {
      setPerms({});
      return {};
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        await loadPerms();
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("adsdesk_token", data.access_token);
      setUser(data.user);
      await loadPerms();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("adsdesk_token");
    setUser(false);
    setPerms(null);
  };

  const can = (section, action = "view") => !!perms?.[section]?.[action];

  return (
    <AuthContext.Provider value={{ user, perms, can, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
